<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: 'StudentsView',

        setup() {

        }
    }
</script>

<style lang="scss" scoped>

</style>